import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
import { cargarPayphoneScript } from '../payphoneLoader';

/**
 * Cajita de Pagos de Payphone embebida — paga la "cotizacion_cliente" de una
 * solicitud de Puerta a Puerta sin salir de la app. Mismo patrón que
 * PagoPayphoneCompraAsistida.js (misma app de Payphone, mismo dominio) — acá
 * no hay rama de transferencia, todo se paga con tarjeta.
 */
export default function PagoPayphonePuertaPuerta({ solicitud }) {
  const contenedorId = `payphone-box-pp-${solicitud.id}`;
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const montado = useRef(false);

  useEffect(() => {
    if (montado.current) return;
    montado.current = true;
    let cancelado = false;

    api.get('/puerta-a-puerta/config-pago/')
      .then(async (res) => {
        const { payphone_token, payphone_store_id } = res.data;
        if (!payphone_token) {
          setError('El pago con tarjeta todavía no está disponible. Contáctanos por WhatsApp.');
          return;
        }
        await cargarPayphoneScript();
        if (cancelado) return;

        const clientTransactionId = `puerta-${solicitud.id}-${Date.now()}`;
        const montoCentavos = Math.round(Number(solicitud.cotizacion_cliente) * 100);

        const config = {
          token: payphone_token,
          clientTransactionId,
          amount: montoCentavos,
          amountWithoutTax: montoCentavos,
          amountWithTax: 0,
          tax: 0,
          service: 0,
          tip: 0,
          currency: 'USD',
          reference: `Puerta a Puerta Ecuafly #${solicitud.id}`,
          // Sin query string propio — ver el comentario en
          // PagoPayphoneCompraAsistida.js (bug real ya encontrado y corregido
          // ahí: Payphone concatena su "?id=&clientTransactionId=" sin
          // revisar si la URL ya tenía un "?"). El id de la solicitud viaja
          // adentro del clientTransactionId (`puerta-<id>-<timestamp>`).
          responseUrl: `${window.location.origin}/pagos/payphone/respuesta`,
          email: solicitud.email,
          lang: 'es',
        };
        if (payphone_store_id) config.storeId = payphone_store_id;

        // eslint-disable-next-line no-undef
        new window.PPaymentButtonBox(config).render(contenedorId);
      })
      .catch(() => setError('No se pudo cargar el pago con tarjeta. Contáctanos por WhatsApp.'))
      .finally(() => { if (!cancelado) setCargando(false); });

    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return <p className="text-sm text-secondary" style={{ marginTop: 'var(--spacing-2)' }}>{error}</p>;
  }

  return (
    <div style={{ marginTop: 'var(--spacing-2)', minWidth: 0 }}>
      {cargando && <p className="text-sm text-secondary">Cargando pago con tarjeta...</p>}
      {/* overflowX + minWidth:0 — la Cajita puede pedir más ancho del que
          tiene la tarjeta; que se desplace ella sola en vez de forzar el
          ancho de toda la página (causaba el "resize" en móvil y PC). */}
      <div id={contenedorId} style={{ overflowX: 'auto', minWidth: 0 }} />
    </div>
  );
}
